import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BillingFree } from '@classes/billing-free';
import { BlobResponse } from '@classes/blob-response';
// import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as _moment from 'moment';
import { EnvConfigurationService } from './env-configuration.service';
const moment = _moment;

@Injectable({
  providedIn: 'root'
})
export class BillingFreeService {
  environment = this.envConfigurationService.environment;

  private basePath = this.environment.apiUrl + '/billingFree';

  constructor(
    private http: HttpClient,
    public envConfigurationService: EnvConfigurationService
  ) { }

  createOrUpdateBillingFree(billingFree?: BillingFree): Observable<BillingFree> {
    if (billingFree?.id) {
      //update
      const url = `${this.basePath}/${billingFree?.id}`;
      return this.http.patch<any>(url,
        billingFree).pipe(map(m => {
          return m
        }));
    } else {
      //create
      return this.http.post<any>(this.basePath,
        billingFree
      ).pipe(map(m => {
        return m
      }));
    }
  }

}
